import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output
} from '@angular/core';

@Component({
  selector: 'app-missing-fields',
  templateUrl: './form.missing-fields.component.html',
  standalone: false
})
export class FormMissingFieldsComponent {
  @Input() public fields: { label: string; value?: number }[] = [];
  @Output() public closed: EventEmitter<void> = new EventEmitter<void>();

  constructor(private readonly _el: ElementRef) {}

  public focus(): void {
    const alert = this._el.nativeElement.querySelector('[role="alert"]');

    if (alert) {
      alert.focus();
    }
  }

  @HostListener('document:keydown.escape')
  public onEscape(): void {
    if (this.fields.length > 0) {
      this.close();
    }
  }

  public close(): void {
    this.focusAnchorButton();
    this.closed.emit();
  }

  // On dismiss, focus must land back on the visible submit button; the
  // anchor wrapper can hold hidden mobile/desktop button variants.
  private focusAnchorButton(): void {
    const panel = this._el.nativeElement.querySelector('[role="alert"]');
    const anchor = panel?.offsetParent;

    if (!anchor) {
      return;
    }

    const buttons: HTMLButtonElement[] = Array.from(
      anchor.querySelectorAll('button')
    );
    const visible = buttons.find(
      (b) => !this._el.nativeElement.contains(b) && b.offsetParent !== null
    );

    visible?.focus();
  }
}
